import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { toast } from 'sonner';
import { Loader2, Calendar } from 'lucide-react';
import emailjs from '@emailjs/browser';

const BookingSection = () => {
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    // Initialize EmailJS
    emailjs.init(process.env.REACT_APP_EMAILJS_PUBLIC_KEY);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Validation
    if (!formData.name.trim()) {
      toast.error('Please enter your name');
      return;
    }
    
    if (!formData.phone.trim()) {
      toast.error('Please enter your phone number');
      return;
    }

    setLoading(true);

    try {
      // EmailJS integration
      const templateParams = {
        name: formData.name,
        phone: formData.phone,
        email: '', // Optional field for Reply To
      };

      const result = await emailjs.send(
        process.env.REACT_APP_EMAILJS_SERVICE_ID,
        process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
        templateParams
      );

      if (result.status === 200) {
        // Track Google Ads form-submit conversions (HYBRID — fires BOTH old + new tags).
        // - NEW: Lead form : Ananth (created 1 Jun 2026) — primary, validates fast
        // - OLD: Zribble Conversions_20/03/25 — kept for historical Smart Bidding signal
        if (window.gtag) {
          window.gtag('event', 'conversion', {
            'send_to': [
              'AW-16474493641/Zeu0CLqC_rYcEMml0689', // NEW
              'AW-16474493641/DReoClzs_awaEMml0689'  // OLD
            ],
            'value': 100.0,
            'currency': 'INR'
          });
        }

        // Fire-and-forget Telegram notification so the team gets an instant
        // ping in addition to the EmailJS email. Failures are intentionally
        // swallowed: a Telegram outage must never break the success UX.
        try {
          fetch(`${process.env.REACT_APP_BACKEND_URL}/api/notify-telegram`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              name: formData.name,
              phone: formData.phone,
              source: 'Website Booking Form',
            }),
          }).catch((err) => console.warn('Telegram notify failed:', err));
        } catch (err) {
          console.warn('Telegram notify error:', err);
        }

        toast.success('🎉 Booking request received! We will call you shortly.');
        setFormData({ name: '', phone: '' });
      }
    } catch (error) {
      console.error('EmailJS Error:', error);
      toast.error('Something went wrong. Please call us directly.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="booking-section">
      <div className="booking-container">
        <div className="booking-content">
          <div className="booking-header">
            <Calendar className="booking-icon" />
            <h2 className="booking-title">Claim Your Happy Hour Offer</h2>
            <p className="booking-subtitle">
              Limited slots. Book now before it's gone.
            </p>
          </div>

          <form onSubmit={handleSubmit} className="booking-form">
            <div className="form-group">
              <Label htmlFor="name" className="form-label">Full Name</Label>
              <Input
                id="name"
                name="name"
                type="text"
                value={formData.name}
                onChange={handleChange}
                placeholder="Enter your name"
                className="form-input"
                disabled={loading}
              />
            </div>

            <div className="form-group">
              <Label htmlFor="phone" className="form-label">Phone Number</Label>
              <Input
                id="phone"
                name="phone"
                type="tel"
                value={formData.phone}
                onChange={handleChange}
                placeholder="+91 XXXXX XXXXX"
                className="form-input"
                disabled={loading}
              />
            </div>

            <Button 
              type="submit" 
              className="booking-submit-btn"
              disabled={loading}
            >
              {loading ? (
                <>
                  <Loader2 className="btn-icon spinning" />
                  Submitting...
                </>
              ) : (
                'Get My Offer'
              )}
            </Button>

            <p className="booking-note">
              By submitting, you agree to receive a call from O2 Nails Hyd to confirm your appointment.
            </p>
          </form>
        </div>
      </div>
    </section>
  );
};

export default BookingSection;
